import {
  SET_PACKAGES,
  PAYMENT_FAIL,
  PAYMENT_SUCCESS,
  RESET,
  START_PAYMENT,
} from '../../actions/cart/cart'
import { START_PAYMENT as WEBSHOP_START_PAYMENT } from '../../actions/webshop/webshop'
import { HIDE_DIALOG } from '../../actions/ui/ui'
import { initialState } from '..'

import type { CartActions } from '../../actions/cart/cart'
import type { HideDialogAction } from '../../actions/ui/ui'
import type { StartPaymentAction } from '../../actions/webshop/webshop'
import { WebshopPackage } from '../../../schema/webshop-package'

export type PaymentStatus =
  | 'pending'
  | 'success'
  | 'error'
  | 'cancelled'
  | ''

type Payment = {
  status: PaymentStatus,
  statusMessage: string,
  basketId: string,
}

export type CartStoreType = {
  packages: Array<WebshopPackage>,
  payment: Payment,
}

const reducer = (
  state: CartStoreType,
  action: CartActions | HideDialogAction | StartPaymentAction,
): CartStoreType => {
  if (!state) return initialState.cart

  switch (action.type) {
    case START_PAYMENT:
    case WEBSHOP_START_PAYMENT: {
      return {
        ...state,
        payment: {
          ...state.payment,
          status: 'pending',
        },
      }
    }

    case PAYMENT_FAIL:
      return {
        ...state,
        payment: {
          ...state.payment,
          statusMessage: action.payload,
          status: 'error',
        },
      }

    case PAYMENT_SUCCESS:
      return {
        ...state,
        payment: {
          ...state.payment,
          status: 'success',
        },
      }

    case SET_PACKAGES:
      return {
        ...state,
        packages: action.payload.packages,
      }

    case RESET:
      return initialState.cart

    case HIDE_DIALOG:
      return {
        ...state,
        payment: {
          ...state.payment,
          status: 'cancelled',
        },
      }

    default:
      return state
  }
}

export default reducer
